import * as React from "react";

//Custom Controls
import BaseInputControl from "./BaseInputControl";

//Types
import { IFloatNumberControlProps } from "@/@types/controls/controls";

function FloatNumberControl(props: IFloatNumberControlProps) {
  const { value, onChange } = props;

  const handleChange = (value: string | number | null, source: string) => {
    if (typeof value === "string") {
      if (value.length > 0) {
        try {
          let valueCorrectDot = value.replace(",", ".");
          const regex = /^-?\d*\.?\d*$/;
          if (regex.test(valueCorrectDot)) {
            onChange(valueCorrectDot, source);
          } else {
            const parsedNumber = parseFloat(valueCorrectDot);
            if (!isNaN(parsedNumber)) {
              onChange(parsedNumber, source);
            }
          }
        } catch {
          onChange(null, source);
        }
        
      } else {
        onChange(null, source);
      }

    } else if (typeof value === "number" ) {
      onChange(value, source);

    } else if (value === null || value === undefined) {
      onChange(null, source);
    }
  };

  const displayValue = (value !== null && value !== undefined) ? value.toString() : "";

  return (
    <BaseInputControl
      {...props}
      onChange={handleChange}
      value={displayValue}
    />
  );
}

export default FloatNumberControl;
